import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getAuth, isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import { CircularProgress, Box, Typography } from '@mui/material';

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const secretId = params.get('secretId');
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const email = window.localStorage.getItem('authEmail');

    // Extract the decryption key from the URL hash (after #k=)
    const decryptionKey = localStorage.getItem('decryptionKey'); // Retrieve the key from sessionStorage

    if (isSignInWithEmailLink(auth, window.location.href) && email) {
      signInWithEmailLink(auth, email, window.location.href)
        .then(() => {
          window.localStorage.removeItem('authEmail');
          // Navigate to the secret page, passing the decryption key in the URL
          localStorage.removeItem('decryptionKey'); // Remove the key from sessionStorage
          navigate(`/view/${secretId}#k=${decryptionKey}`, { replace: true });
        })
        .catch((error) => {
          console.error(error);
          alert('Authentication failed.');
        });
    }
  }, [navigate, secretId]);

  return (
    <Box sx={{ mt: 5, textAlign: 'center' }}>
      <CircularProgress />
      <Typography variant="body1" sx={{ mt: 2 }}>Verifying your email...</Typography>
    </Box>
  );
};

export default VerifyEmail;